import styled from 'styled-components'

export const Box = styled.span`
  white-space: nowrap;
  display: contents;
`
